// react
import { useEffect, memo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
// utils
import useAppStore from '@/store/app.ts';
import { ACCOUNT_URL, PATHS } from '@/constants';

const AuthCallback = () => {
    const setTokens = useAppStore((state) => state.setTokens);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const accessToken = searchParams.get('access_token') ?? '';
    const refreshToken = searchParams.get('refresh_token') ?? '';
    const expiresIn = searchParams.get('expires_in') ?? 0;
    const redirectTo = searchParams.get('redirect_to') ?? '';

    useEffect(() => {
        if (accessToken && refreshToken && expiresIn) {
            setTokens(accessToken, refreshToken, +expiresIn);
            if (redirectTo) {
                globalThis.location.href = redirectTo;
            } else {
                navigate(PATHS.dashboard);
            }
        } else {
            globalThis.location.href = ACCOUNT_URL;
        }
    }, [accessToken, refreshToken, expiresIn, setTokens, navigate, redirectTo]);
    return <div />;
};

export default memo(AuthCallback);
